import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useMst } from "../store/root";

import {
  CompositionList,
  CompositionListMenu,
  RenderButton,
  TopBar,
} from "../components/baseComponents";
import butterflyAnimation from "../assets/animations/butterflies.json";
import lottie, { AnimationItem } from "lottie-web";
import styles from "./ExtensionPanel.module.scss";
import { NoProjects } from "./NoProjects";

type Props = {
  environment: string;
};
const LIVE_CONNECTION_TIMEOUT_MS = 30000;

const ExtensionPanel = observer(({ environment }: Props) => {
  const [selectProjectText, setSelectProjectText] = useState({ __html: `` });
  const [isLiveConnection, setIsLiveConnection] = useState(true);

  const {
    projectStore: {
      selectedProjectId,
      setSelectedProjectId,
      selectedProject,
      noProjects,
      getAEVersion,
    },
    renderStore: { isRendering },
    compositionStore: {setSelectedCompositions, setRenderedCompositions},
    authStore: { userEmail },
  } = useMst();

  // If is internal user, add account name next to each project
  const [isInternalUser, setIsInternalUser] = useState(false);
  
  useEffect(() => {
    if (userEmail) {
      const domain = userEmail.substring(userEmail.indexOf("@") + 1);
      domain === "blings.io" && setIsInternalUser(true);
    }
  }, [userEmail]);

  useEffect(() => {
    const liveConnectionTimeout = setInterval(() => {
      setIsLiveConnection(window.navigator.onLine);
    }, LIVE_CONNECTION_TIMEOUT_MS);
    return () => {
      clearInterval(liveConnectionTimeout);
    };
  }, []);
  return (
    <div className={styles.ExtensionPanel}>
      <div className={styles.TopRow}>
        <TopBar
          selectedProjectId={selectedProject?.id}
          setSelectedProjectId={setSelectedProjectId}
          selectedProjectName={selectedProject?.title}
          setSelectedCompositions={setSelectedCompositions}
          setRenderedCompositions={setRenderedCompositions}
          environment={environment}
          email={userEmail}
          isRendering={isRendering}
        />
      </div>

      {noProjects && <NoProjects />}

      {!selectedProjectId && !noProjects && (
        <div className={styles.NoProjectSelected}>
          <div id="no-selected-project"></div>
          <p
            className={styles.Speech}
            dangerouslySetInnerHTML={selectProjectText}
          ></p>
        </div>
      )}
      {!!selectedProjectId && (
        <>
          {isLiveConnection ? (
            <>
              <CompositionListMenu />
              <CompositionList />
              <RenderButton />
            </>
          ) : (
            <p>Oh Oh, something happened. Try again in few seconds.</p>
          )}
        </>
      )}
    </div>
  );
});

export default ExtensionPanel;
